import { Notify } from 'vant';

Notify.setDefaultOptions({
    onClick: Notify.clear,
    duration: 1000,
});
